// extracted by mini-css-extract-plugin
export var about = "innovations-module--about--2F4mH";
export var videobox = "innovations-module--videobox--2BpGl";
export var buttonRow = "innovations-module--buttonRow--3c5fZ";